
export const getDefaultPaperType = (deliveryPaperTypes) => {
    return (
        deliveryPaperTypes.find((paperType) => paperType.default === true) ??
        deliveryPaperTypes[0]
    );
};